import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddBoxIcon from '@mui/icons-material/AddBox';
import AddIcon from '@mui/icons-material/Add';
import {
  Box,
  useTheme,
  IconButton,
  Stack,
  Tab,
  Tabs,
  ThemeProvider,
} from '@mui/material';
import {
  getDefaultAlertProps,
  getViewType,
  unixToLocal,
} from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { IAlertProps } from '../../interface/IAlertProps';
import {
  MAIN_COLOR_STRING,
  PAGE_SIZE_DEVICES,
  PC_VIEW,
  START_PAGE_SIZE_DEVICES,
} from '../../constant/constants';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IApiResult } from '../../interface/IApiResult';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { AppIdDto } from '../../dto/AppIdDto';
import { TokenDto } from '../../dto/TokenDto';
import { MyTextFiled } from '../UI/MyTextField';
import { FactoryBodyHeaderDiv } from '../body-header/FactoryBodyHeaderDiv';
import { apiGetServiceAppId } from '../../service/service-token/apiGetServiceAppId';
import { apiGetServiceTokens } from '../../service/service-token/apiGetServiceTokens';
import { apiDeleteServiceAppId } from '../../service/service-token/apiDeleteServiceAppId';
import { apiAddServiceApId } from '../../service/service-token/apiAddServiceAppId';
import { apiDeleteServiceToken } from '../../service/service-token/apiDeleteServiceToken';
import { apiAddServiceToken } from '../../service/service-token/apiAddServiceToken';
import { apiGetSertMqtt } from '../../service/sert-mqtt/apiGetSertMqtt';
import { SertMqttDto } from '../../dto/SertMqttDto';
import { apiDeleteSertMqtt } from '../../service/sert-mqtt/apiDeleteSertMqtt';
import { apiAddSertMqtt } from '../../service/sert-mqtt/apiAddSertMqtt';
import { MyAutoComplete } from '../UI/MuAutoComplete';
import { SertMqttEnum } from '../../enum/SertMqttEnum';

export const SertMqttDiv = () => {
  const [pageSize, setPageSize] = React.useState(START_PAGE_SIZE_DEVICES);
  const { t } = useTranslation();
  const [backDrop, setBackDrop] = useState(false);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [sertAddDto, setSertAddDto] = useState<SertMqttDto>({
    id: -1,
    sertName: '',
    iden: '',
    type: -1,
    datetime: -1,
  });
  const [sertDtos, setSertDtos] = useState<SertMqttDto[]>([]);

  const getSertMqtt = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetSertMqtt();
    if (apiResult.isSuccess) {
      setSertDtos(apiResult.data.mqtt);
    } else {
      setAlertProps({
        message: t('errotServer'),
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const deleteSertMqtt = async (dto: SertMqttDto) => {
    const apiResult: IApiResult = await apiDeleteSertMqtt(dto);
    if (apiResult.isSuccess) {
      getSertMqtt();
    } else {
      setAlertProps({
        message: t('errotServer'),
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const addSertMqtt = async (dto: SertMqttDto) => {
    const apiResult: IApiResult = await apiAddSertMqtt(dto);
    if (apiResult.isSuccess) {
      getSertMqtt();
      setSertAddDto({
        id: -1,
        sertName: '',
        iden: '',
        type: -1,
        datetime: -1,
      });
    } else {
      setAlertProps({
        message: t('errotServer'),
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const [checkHelper, setCheckHelper] = useState(false);

  const handelCreate = async () => {
    if (sertAddDto?.sertName === '' || sertAddDto?.type === -1) {
      setCheckHelper(true);
      return;
    }
    await addSertMqtt(sertAddDto);
  };

  const theme = useTheme();

  useEffect(() => {
    getSertMqtt();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns: GridColDef[] = [
    {
      field: 'sertName',
      headerName: t('sertName'),
      renderHeader: () => <strong>{t('sertName')}</strong>,
      flex: 1,
      minWidth: 150,
      editable: false,
      renderCell: (row) => row.row.sertName,
    },
    {
      field: 'iden',
      headerName: t('sertIden'),
      renderHeader: () => <strong>{t('sertIden')}</strong>,
      flex: 1,
      minWidth: 150,
      editable: false,
      renderCell: (row) => row.row.iden,
    },
    {
      field: 'type',
      headerName: t('sertType'),
      renderHeader: () => <strong>{t('sertType')}</strong>,
      flex: 1,
      minWidth: 150,
      editable: false,
      renderCell: (row) => SertMqttEnum[row.row.type],
    },
    {
      field: 'id',
      type: 'actions',
      width: 35,
      headerName: '',
      hide: true,
      editable: false,
      sortable: false,
      filterable: false,
      renderCell: (row) => (
        <Stack direction="row" width="100%" justifyContent="center">
          <IconButton
            size="small"
            title={t('tooltipDelete')}
            onClick={() => deleteSertMqtt(row.row)}
          >
            <DeleteForeverIcon
              fontSize="small"
              sx={{
                color: 'red',
              }}
            />
          </IconButton>
        </Stack>
      ),
    },
  ];

  const other = {
    autoHeight: true,
    showCellRightBorder: true,
    showColumnRightBorder: true,
  };

  return (
    <div style={{ userSelect: 'text' }}>
      <BackDropDiv open={backDrop} />
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <Stack width="100%" alignItems="center" marginBottom="20px" spacing={2}>
        <Stack width="90%">
          <FactoryBodyHeaderDiv title={t('sertMqtt')} />
        </Stack>
        <Stack width="90%" spacing={1}>
          {false && (
            <Stack direction="row" spacing={1}>
              <MyTextFiled
                value={sertAddDto.sertName}
                autoComplete="off"
                onChange={(e) =>
                  setSertAddDto({ ...sertAddDto, sertName: e.target.value })
                }
                size="small"
                error={checkHelper}
                label={t('sertName')}
              />
              <MyAutoComplete
                value={
                  sertAddDto.type !== undefined && sertAddDto.type !== -1
                    ? SertMqttEnum[sertAddDto.type]
                    : ''
                }
                onChange={(e, v) =>
                  setSertAddDto({
                    ...sertAddDto,
                    type: Object.values(SertMqttEnum).indexOf(v),
                  })
                }
                error={checkHelper}
                arrayList={Object.values(SertMqttEnum).filter(
                  (value) => typeof value === 'string'
                )}
                size="small"
                label={t('sertType')}
              />
              <Stack alignItems="center">
                <IconButton
                  sx={{ color: MAIN_COLOR_STRING }}
                  onClick={handelCreate}
                >
                  <AddIcon />
                </IconButton>
              </Stack>
            </Stack>
          )}
          <Box
            sx={{
              '& .app-theme-cell': {
                fontFamily: 'sans-serif',
              },
            }}
          >
            <ThemeProvider theme={theme}>
              <DataGrid
                sx={{
                  '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                    py: 1,
                    fontSize: '100px',
                  },
                  '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                    py: '5px',
                  },
                  '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                    py: '10px',
                  },
                  '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus-within':
                    {
                      outline: 'none !important',
                    },
                }}
                getRowHeight={() => 'auto'}
                columns={columns}
                rows={sertDtos}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...other}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={PAGE_SIZE_DEVICES}
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
              />
            </ThemeProvider>
          </Box>
        </Stack>
      </Stack>
    </div>
  );
};
